import React from "react"
import SocialLinks from "../constants/socialLinks"
const Footer = () => {
  return <footer className="footer">
    <SocialLinks styleClass="footer-links"></SocialLinks>
  </footer>
}

export default Footer
